import { Info } from 'lucide-react';

export function TrajectoryLegend() {
  return (
    <div className="fixed bottom-36 right-6 z-20 bg-background/95 backdrop-blur-md rounded-xl shadow-lg border p-3 w-[200px]">
      <div className="flex items-center gap-2 mb-2">
        <Info className="h-3 w-3 text-primary" />
        <p className="text-xs font-semibold">Legenda do Trajeto</p>
      </div>
      
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <div className="w-8 h-1.5 bg-blue-500 rounded" />
          <span className="text-[10px]">0-5 km/h (Parado)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-1.5 bg-green-500 rounded" />
          <span className="text-[10px]">6-40 km/h (Normal)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-1.5 bg-yellow-500 rounded" />
          <span className="text-[10px]">41-80 km/h (Rápido)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-1.5 bg-red-500 rounded" />
          <span className="text-[10px]">80+ km/h (Crítico)</span>
        </div>
      </div>
      
      <div className="flex items-center gap-2 mt-3 pt-2 border-t">
        <div className="w-3 h-3 bg-red-600 rounded-full border-2 border-white shadow-sm" />
        <span className="text-[10px]">Parada &gt;3min</span>
      </div>
    </div>
  );
}
